<template>
  <div class="adj-overlay" v-if="visible" @click.self="close">
    <div class="adj-box">
      <h4>调整评分：{{ questionText }}</h4>
      <p>当前评分：{{ currentScore }}/5 ｜ 差：{{ questionLow }} ｜ 好：{{ questionHigh }}</p>
      <div class="adj-scores">
        <div
          v-for="s in 5"
          :key="s"
          class="adj-score"
          :class="{ selected: s === selectedScore }"
          @click="selectScore(s)"
        >{{ s }}</div>
      </div>
      <button class="adj-close" @click="close">确认</button>
    </div>
  </div>
</template>

<script>
/**
 * 评分调整弹窗
 * 全局使用：$root.$emit('openAdjust', { qid, dimId })
 */
import { DIMENSIONS } from '../../utils/constants'
import { mapState } from 'vuex'

export default {
  name: 'AdjustModal',
  data() {
    return {
      visible: false,
      qid: null,
      questionText: '',
      questionLow: '',
      questionHigh: '',
      selectedScore: null
    }
  },
  computed: {
    ...mapState('diagnosis', ['scores']),
    currentScore() {
      return this.qid ? (this.scores[this.qid] || '-') : '-'
    }
  },
  mounted() {
    this.$root.$on('openAdjust', this.open)
  },
  beforeDestroy() {
    this.$root.$off('openAdjust', this.open)
  },
  methods: {
    open({ qid }) {
      const dim = DIMENSIONS.find(d => d.questions.some(q => q.id === qid))
      if (!dim) return
      const q = dim.questions.find(x => x.id === qid)
      if (!q) return

      this.qid = qid
      this.questionText = q.text.substring(0, 30) + '...'
      this.questionLow = q.low
      this.questionHigh = q.high
      this.selectedScore = this.scores[qid] || null
      this.visible = true
    },

    selectScore(s) {
      this.selectedScore = s
      if (this.qid) {
        this.$store.commit('diagnosis/SET_SCORE', { qid: this.qid, score: s })
        this.$store.commit('diagnosis/CLEAR_BRM_SOURCE', this.qid)
      }
    },

    close() {
      this.visible = false
      this.qid = null
    }
  }
}
</script>
